var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"progress-status border"},[_c('journey-goal-setting-tabs'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }